export { default, getServerSideProps } from '@/entries/Home';
